import { NETWORK } from '../types/enums';

const HIRO_API_MAINNET = 'https://api.hiro.so/extended/v1';
const HIRO_API_TESTNET = 'https://api.testnet.hiro.so/extended/v1';

const getHiroApiUrl = (network: NETWORK) =>
  network === NETWORK.MAINNET ? HIRO_API_MAINNET : HIRO_API_TESTNET;

export const getHiroNonce = (address: string, network: NETWORK) =>
  fetch(`${getHiroApiUrl(network)}/address/${address}/nonces?unanchored=true`);
